export function countWords(input: string) {
  // remove special character
  const mappedStr = input.replace(/[\u007F-\u00FE]/g, " ");

  // count number of english words by remove all chinese
  const mappedStrEnglishOnly = mappedStr.replace(/[^!-~\d\s]+/gi, " ");

  const matchedEnglishWords =
    mappedStrEnglishOnly.match(/[\u00ff-\uffff]|\S+/g);
  const englishCount = matchedEnglishWords ? matchedEnglishWords.length : 0;

  // count number of chinese words by remove all english
  const mappedStrChineseOnly = mappedStr.replace(/[!-~\d\s]+/gi, "");
  const matchedChineseWords =
    mappedStrChineseOnly.match(/[\u00ff-\uffff]|\S+/g);
  const chineseCount = matchedChineseWords ? matchedChineseWords.length : 0;

  return englishCount + chineseCount;
}
